// Imports: local files.
import ApiClient from '../../services/ApiClient';

// Action Types: Get All FAQs.
export const GET_ALL_FAQS_START = 'GET_ALL_FAQS_START';
export const GET_ALL_FAQS_SUCCESS = 'GET_ALL_FAQS_SUCCESS';
export const GET_ALL_FAQS_FAILED = 'GET_ALL_FAQS_FAILED';
export const GET_ALL_FAQS_RESET = 'GET_ALL_FAQS_RESET';

// Action Types: Get One FAQ.
export const GET_ONE_FAQ_START = 'GET_ONE_FAQ_START';
export const GET_ONE_FAQ_SUCCESS = 'GET_ONE_FAQ_SUCCESS';
export const GET_ONE_FAQ_FAILED = 'GET_ONE_FAQ_FAILED';
export const GET_ONE_FAQ_RESET = 'GET_ONE_FAQ_RESET';

// Action Types: Create New FAQ.
export const CREATE_FAQ_START = 'CREATE_FAQ_START';
export const CREATE_FAQ_SUCCESS = 'CREATE_FAQ_SUCCESS';
export const CREATE_FAQ_FAILED = 'CREATE_FAQ_FAILED';
export const CREATE_FAQ_RESET = 'CREATE_FAQ_RESET';

// Action Types: Update One FAQ.
export const UPDATE_ONE_FAQ_START = 'UPDATE_ONE_FAQ_START';
export const UPDATE_ONE_FAQ_SUCCESS = 'UPDATE_ONE_FAQ_SUCCESS';
export const UPDATE_ONE_FAQ_FAILED = 'UPDATE_ONE_FAQ_FAILED';
export const UPDATE_ONE_FAQ_RESET = 'UPDATE_ONE_FAQ_RESET';

// Action Types: Delete One FAQ.
export const DELETE_ONE_FAQ_START = 'DELETE_ONE_FAQ_START';
export const DELETE_ONE_FAQ_SUCCESS = 'DELETE_ONE_FAQ_SUCCESS';
export const DELETE_ONE_FAQ_FAILED = 'DELETE_ONE_FAQ_FAILED';
export const DELETE_ONE_FAQ_RESET = 'DELETE_ONE_FAQ_RESET';

// Action Creators: Get All FAQs.
const getAllFaqsStart = (payload) => ({
  type: GET_ALL_FAQS_START,
  payload,
});
const getAllFaqsSuccess = (payload) => ({
  type: GET_ALL_FAQS_SUCCESS,
  payload,
});
const getAllFaqsFailed = (payload) => ({
  type: GET_ALL_FAQS_FAILED,
  payload,
});
const getAllFaqsReset = () => ({ type: GET_ALL_FAQS_RESET });

// Action Creators: Get One FAQ.
const getOneFaqStart = (payload) => ({
  type: GET_ONE_FAQ_START,
  payload,
});
const getOneFaqSuccess = (payload) => ({
  type: GET_ONE_FAQ_SUCCESS,
  payload,
});
const getOneFaqFailed = (payload) => ({
  type: GET_ONE_FAQ_FAILED,
  payload,
});
const getOneFaqReset = () => ({ type: GET_ONE_FAQ_RESET });

// Action Creators: Create New FAQ.
const createFaqStart = (payload) => ({
  type: CREATE_FAQ_START,
  payload,
});
const createFaqSuccess = (payload) => ({
  type: CREATE_FAQ_SUCCESS,
  payload,
});
const createFaqFailed = (payload) => ({
  type: CREATE_FAQ_FAILED,
  payload,
});
const createFaqReset = () => ({ type: CREATE_FAQ_RESET });

// Action Creators: Update One FAQ.
const updateOneFaqStart = (payload) => ({
  type: UPDATE_ONE_FAQ_START,
  payload,
});
const updateOneFaqSuccess = (payload) => ({
  type: UPDATE_ONE_FAQ_SUCCESS,
  payload,
});
const updateOneFaqFailed = (payload) => ({
  type: UPDATE_ONE_FAQ_FAILED,
  payload,
});
const updateOneFaqReset = () => ({ type: UPDATE_ONE_FAQ_RESET });

// Action Creators: Delete One FAQ.
const deleteOneFaqStart = (payload) => ({
  type: DELETE_ONE_FAQ_START,
  payload,
});
const deleteOneFaqSuccess = (payload) => ({
  type: DELETE_ONE_FAQ_SUCCESS,
  payload,
});
const deleteOneFaqFailed = (payload) => ({
  type: DELETE_ONE_FAQ_FAILED,
  payload,
});
const deleteOneFaqReset = () => ({ type: DELETE_ONE_FAQ_RESET });

// Actions: Get All FAQs.
export const getAllFaqs = (payload) => {
  return async (dispatch) => {
    dispatch(
      getAllFaqsStart({
        loading: true,
        success: false,
        data: null,
        error: false,
        errorMessage: null,
      })
    );

    try {
      const { page, limit, pagination, type, selectedLanguage } = payload;
      const params = { page, limit, pagination };
      if (type) params.type = type;
      if (selectedLanguage) params.selectedLanguage = selectedLanguage;

      const result = await ApiClient.get('faq', {
        params,
      });
      if (result.data?.success) {
        const { faqs } = result.data.data;
        dispatch(
          getAllFaqsSuccess({
            loading: false,
            success: true,
            data: { faqs },
            error: false,
            errorMessage: null,
          })
        );
      } else {
        dispatch(
          getAllFaqsFailed({
            loading: false,
            success: false,
            data: null,
            error: true,
            errorMessage: result.data?.error || 'Internal Server Error!',
          })
        );
      }
    } catch (error) {
      dispatch(
        getAllFaqsFailed({
          loading: false,
          success: false,
          data: null,
          error: true,
          errorMessage: error.message || 'Internal Server Error!',
        })
      );
    }
  };
};

// Actions: Clear Get All FAQs.
export const clearGetAllFaqs = () => getAllFaqsReset();

// Actions: Get One FAQ.
export const getOneFaq = (payload) => {
  return async (dispatch) => {
    dispatch(
      getOneFaqStart({
        loading: true,
        success: false,
        data: null,
        error: false,
        errorMessage: null,
      })
    );

    try {
      const { faqId } = payload;
      const result = await ApiClient.get(`faq/${faqId}`);
      if (result.data?.success) {
        const { faq } = result.data.data;
        dispatch(
          getOneFaqSuccess({
            loading: false,
            success: true,
            data: { faq },
            error: false,
            errorMessage: null,
          })
        );
      } else {
        dispatch(
          getOneFaqFailed({
            loading: false,
            success: false,
            data: null,
            error: true,
            errorMessage: result.data?.error || 'Internal Server Error!',
          })
        );
      }
    } catch (error) {
      dispatch(
        getOneFaqFailed({
          loading: false,
          success: false,
          data: null,
          error: true,
          errorMessage: error.message || 'Internal Server Error!',
        })
      );
    }
  };
};

// Actions: Clear Get One FAQ.
export const clearGetOneFaq = () => getOneFaqReset();

// Actions: Create New FAQ.
export const createFaq = (payload, options) => {
  return async (dispatch) => {
    dispatch(
      createFaqStart({
        loading: true,
        success: false,
        data: null,
        error: false,
        errorMessage: null,
      })
    );

    const { enQuestion, enAnswer, ukrQuestion, ukrAnswer, czQuestion, czAnswer, type } = payload;
    const { showToast, toastNotification, onSuccessMessage, onFailMessage } = options;

    try {
      const result = await ApiClient.post('faq', {
        enQuestion,
        enAnswer,
        ukrQuestion,
        ukrAnswer,
        czQuestion,
        czAnswer,
        type,
      });
      if (result.data?.success) {
        const { faq } = result.data.data;
        dispatch(
          createFaqSuccess({
            loading: false,
            success: true,
            data: { faq },
            error: false,
            errorMessage: null,
          })
        );

        showToast && toastNotification('success', onSuccessMessage);
      } else {
        dispatch(
          createFaqFailed({
            loading: false,
            success: false,
            data: null,
            error: true,
            errorMessage: result.data?.error || 'Internal Server Error!',
          })
        );
        showToast && toastNotification('error', onFailMessage);
      }
    } catch (error) {
      dispatch(
        createFaqFailed({
          loading: false,
          success: false,
          data: null,
          error: true,
          errorMessage: error.message || 'Internal Server Error!',
        })
      );
      showToast && toastNotification('error', onFailMessage);
    }
  };
};

// Actions: Clear Create New FAQ.
export const clearCreateFaq = () => createFaqReset();

// Actions: Update One FAQ.
export const updateOneFaq = (payload, options) => {
  return async (dispatch) => {
    dispatch(
      updateOneFaqStart({
        loading: true,
        success: false,
        data: null,
        error: false,
        errorMessage: null,
      })
    );

    const { faqId, enQuestion, enAnswer, ukrQuestion, ukrAnswer, czQuestion, czAnswer, type } = payload;
    const { showToast, toastNotification, onSuccessMessage, onFailMessage } = options;
    try {
      const result = await ApiClient.put(`faq/${faqId}`, {
        enQuestion,
        enAnswer,
        ukrQuestion,
        ukrAnswer,
        czQuestion,
        czAnswer,
        type,
      });
      if (result.data?.success) {
        const { faq } = result.data.data;
        dispatch(
          updateOneFaqSuccess({
            loading: false,
            success: true,
            data: { faq },
            error: false,
            errorMessage: null,
          })
        );
        showToast && toastNotification('success', onSuccessMessage);
      } else {
        dispatch(
          updateOneFaqFailed({
            loading: false,
            success: false,
            data: null,
            error: true,
            errorMessage: result.data?.error || 'Internal Server Error!',
          })
        );
        showToast && toastNotification('error', onFailMessage);
      }
    } catch (error) {
      dispatch(
        updateOneFaqFailed({
          loading: false,
          success: false,
          data: null,
          error: true,
          errorMessage: error.message || 'Internal Server Error!',
        })
      );
      showToast && toastNotification('error', onFailMessage);
    }
  };
};

// Actions: Clear Update One FAQ.
export const clearUpdateOneFaq = () => updateOneFaqReset();

// Actions: Delete One FAQ.
export const deleteOneFaq = (payload, options) => {
  return async (dispatch) => {
    dispatch(
      deleteOneFaqStart({
        loading: true,
        success: false,
        data: null,
        error: false,
        errorMessage: null,
      })
    );

    const { faqId } = payload;
    const { showToast, toastNotification, onSuccessMessage, onFailMessage } = options;

    try {
      const result = await ApiClient.delete(`faq/${faqId}`);
      if (result.data?.success) {
        const { faq } = result.data.data;
        dispatch(
          deleteOneFaqSuccess({
            loading: false,
            success: true,
            data: { faq },
            error: false,
            errorMessage: null,
          })
        );
        showToast && toastNotification('success', onSuccessMessage);
      } else {
        dispatch(
          deleteOneFaqFailed({
            loading: false,
            success: false,
            data: null,
            error: true,
            errorMessage: result.data?.error || 'Internal Server Error!',
          })
        );
        showToast && toastNotification('error', onFailMessage);
      }
    } catch (error) {
      dispatch(
        deleteOneFaqFailed({
          loading: false,
          success: false,
          data: null,
          error: true,
          errorMessage: error.message || 'Internal Server Error!',
        })
      );
      showToast && toastNotification('error', onFailMessage);
    }
  };
};

// Actions: Clear Delete One FAQ.
export const clearDeleteOneFaq = () => deleteOneFaqReset();
